import { vwoAccountId, vwoKeys, currentExperiments } from "../config/vwoKeys";
import Utility from "./utility";
import vwoSDK from "vwo-node-sdk";
import {
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT
} from "../config/vwoKeys";

const getSettingFile = async (experimentName) => {
  try {
    const vwoKey =
      window._siteProps_?.props?.build_env_var === "production"
        ? vwoKeys[experimentName].prod
        : vwoKeys[experimentName].stage;

    const vwoSettingFile = await vwoSDK.getSettingsFile(vwoAccountId, vwoKey);
    const vwoClientInstance = await vwoSDK.launch({
      isDevelopmentMode: false,
      settingsFile: vwoSettingFile,
    });

    return vwoClientInstance;
  } catch (e) {
    return {
      track: function () {
        return;
      },
      activate: function () {
        return;
      },
    };
  }
};

const updateIntoStoredVwoVariations = (experimentName, variationName) => {
  let __ = Utility.tryJsonParse(sessionStorage.VWO_PWA_V2_VARIATIONS);
  __[experimentName] = variationName;
  sessionStorage.VWO_PWA_V2_VARIATIONS = JSON.stringify(__);
  return;
};

const asyncCallWithTimeout = async (asyncPromise, timeLimit) => {
  let timeoutHandle;

  const timeoutPromise = new Promise((_resolve, reject) => {
    timeoutHandle = setTimeout(() => {
      reject(new Error('Async call timeout limit reached'));
    }, timeLimit);
  });

  return Promise.race([asyncPromise, timeoutPromise]).then(result => {
    clearTimeout(timeoutHandle);
    return result;
  });
};

const checkIfVariantNotNull = (variationName) => {
  if (
    variationName === undefined ||
    variationName === null ||
    variationName === 'null' ||
    variationName === ''
  ) {
    return true;
  }
  return false;
};

const getVariation = async (experimentName) => {
  if (!experimentName) return { "": "" };

  try {
    let queryParams = Utility.getQueryFromUrl();
    if (queryParams[experimentName]) {
      updateIntoStoredVwoVariations(
        experimentName,
        queryParams[experimentName]
      );
    }

    let _ = Utility.tryJsonParse(sessionStorage.VWO_PWA_V2_VARIATIONS);
    
    if (experimentName in _) {
      const variation = _[experimentName];
      if (
        experimentName === VWO_NEXTGEN_HOMEPAGE_EXPERIMENT && 
        checkIfVariantNotNull(variation)
      ) {
        updateIntoStoredVwoVariations(experimentName, VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S);
        return { [experimentName]: VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S };
      }
      else {
        return { [experimentName]: _[experimentName] };
      }
    }
    //else return { [experimentName]: "" };

    const vwoClientInstance = await getSettingFile(experimentName);
    const deafultVWOID = localStorage.AB_TEST_VWO_ID || "";
    const VWOMID =
      deafultVWOID ||
      window?.crypto?.getRandomValues(new Uint32Array(1))[0].toString();
    if (!deafultVWOID) {
      localStorage.AB_TEST_VWO_ID = VWOMID;
    }

    let variationName = null;

    const vwoClientInstanceActivateFunc = async () => {
      try {
        variationName = await asyncCallWithTimeout(
          vwoClientInstance.activate(experimentName, VWOMID),
          2000
        );
      } catch (err) {}
    };
  
    await vwoClientInstanceActivateFunc();

    if(
      experimentName === VWO_NEXTGEN_HOMEPAGE_EXPERIMENT &&
      checkIfVariantNotNull(variationName)
    ) {
      variationName = VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S;
    }

    updateIntoStoredVwoVariations(experimentName, variationName);

    return { [experimentName]: variationName };
  } catch (e) {
    return { [experimentName]: "" };
  }
};

const getExperimentsPromiseArray = () => {
  let experimentPromiseArray = [];
  for (const experiment of currentExperiments) {
    experimentPromiseArray.push(getVariation(experiment));
  }
  return experimentPromiseArray;
};

export { getSettingFile, getVariation, getExperimentsPromiseArray };
